import { ImageIcon } from "lucide-react";
import { portfolioItems } from "@/data/portfolio";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const PortfolioSection = () => {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="bg-white py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="09"
          kicker="Portfolio"
          title="Dokumentasi Pekerjaan"
          description="Contoh area dokumentasi pekerjaan maintenance AC & HVAC. Gambar berikut merupakan placeholder yang dapat diganti dengan foto asli CV Angkasa Briliant."
        />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {portfolioItems.map((item, i) => (
            <Reveal key={item.id} delay={(i % 4) * 0.06}>
              <figure
                data-testid={`portfolio-item-${item.id}`}
                className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-slate-100"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                {/* dark scrim */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/10 to-transparent" />

                {/* editable placeholder badge */}
                {item.isPlaceholder && (
                  <span
                    data-testid={`portfolio-placeholder-${item.id}`}
                    className="absolute right-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-slate-700 backdrop-blur-sm"
                  >
                    <ImageIcon className="h-3 w-3" />
                    Placeholder
                  </span>
                )}

                <figcaption className="absolute inset-x-0 bottom-0 p-5">
                  <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-[#E0A400]">
                    {item.category}
                  </span>
                  <h3 className="mt-1 text-base font-bold text-white">
                    {item.title}
                  </h3>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 text-center text-sm text-slate-400">
            Foto asli pekerjaan CV Angkasa Briliant dapat ditambahkan kapan saja
            melalui konfigurasi data portfolio.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default PortfolioSection;
